"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const exceptions_1 = require("./exceptions");
const encode = (val) => {
    return encodeURIComponent(val)
        .replace(/%40/gi, '@')
        .replace(/%3A/gi, ':')
        .replace(/%24/g, '$')
        .replace(/%2C/gi, ',')
        .replace(/%20/g, '+')
        .replace(/%5B/gi, '[')
        .replace(/%5D/gi, ']');
};
const paramsSerializer = (data) => {
    if (!data)
        return '';
    const parts = [];
    const keys = data instanceof Object ? Object.keys(data) : data;
    for (let key of keys) {
        //@ts-ignore
        let val = data[key];
        if (val === null || typeof val === 'undefined')
            continue;
        // if (Array.isArray(val)) key = key + '[]'
        if (Array.isArray(val))
            key = key;
        else
            val = [val];
        val.forEach((v) => {
            if (v instanceof Date)
                v = v.toISOString();
            else if (typeof v == 'object')
                v = JSON.stringify(v);
            parts.push(encode(key) + '=' + encode(v));
        });
    }
    return '?' + parts.join('&');
};
/**
 * Gestore delle richieste http
 *
 * @export
 * @class Request
 */
class Request {
    /**
     * @param {string} baseURL
     * @memberof Request
     */
    constructor(baseURL) {
        // const csrfToken = (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content
        this.baseURL = baseURL;
        this.headers = {
            Accept: 'application/json',
        };
        // if (csrfToken) {
        // 	this.headers['X-CSRF-TOKEN'] = csrfToken
        // }
    }
    /**
     * Gestore eccezioni di base
     *
     * @private
     * @param {any} error
     * @memberof Request
     */
    responseInterceptorExceptionHandler(status, statusText, data, response) {
        switch (status) {
            case 400:
                return new exceptions_1.BadRequest(statusText, data);
            case 401:
                return new exceptions_1.Unauthorized(statusText, data);
            case 403:
                return new exceptions_1.Forbidden(statusText, data);
            case 404:
                return new exceptions_1.NotFound(statusText, data);
            case 405:
                return new exceptions_1.MethodNotAllowed(statusText, data);
            case 409:
                return new exceptions_1.Conflict(statusText, data);
            case 413:
                return new exceptions_1.PayloadTooLarge(statusText, data);
            case 422:
                return new exceptions_1.UnprocessableEntity(statusText, data);
            case 423:
                return new exceptions_1.Loked(statusText, data);
            case 429:
                return new exceptions_1.TooManyAttempts(statusText, data);
            case 451:
                return new exceptions_1.UnavailableForLegalReasons(statusText, data);
            case 502:
                return new exceptions_1.BadGateway(statusText, data);
            default:
                return new exceptions_1.ApiException(statusText, data);
        }
    }
    /**
     * Gestore delle reisposte http
     *
     * @private
     * @param {Promise<Response>} request
     * @returns {Promise<any>}
     * @throws {UnprocessableEntityException | UnauthorizedException | NotFoundException | PayloadTooLargeException | TooManyAttemptsException}
     * @memberof Request
     */
    async resolveRequest(request) {
        const response = await request;
        const data = await response.json();
        if (response.ok) {
            return data;
        }
        const error = this.responseInterceptorExceptionHandler(response.status, response.statusText, data, response);
        this.httpErrorInterceptor && this.httpErrorInterceptor(error);
        throw error;
    }
    /**
     * Setta il COntent-Type dell'header della ricchiesta se la richiesta continene dei dati da ivaire
     *
     * @private
     * @param {any} _headers
     * @param {(Object | FormData)} [data]
     * @return any
     * @memberof Request
     */
    setContentTypeFromPostData(_headers, data) {
        const headers = { ..._headers };
        if (typeof data === 'undefined' || data instanceof FormData)
            delete headers['Content-Type'];
        else
            headers['Content-Type'] = 'application/json';
        return headers;
    }
    /**
     * Esegue una richiesta
     *
     * @memberof Request
     */
    async request(config) {
        const { url, method, headers, body } = config;
        return this.resolveRequest(fetch(this.baseURL + url, {
            method,
            headers: { ...headers, ...this.headers },
            body: body,
        }));
    }
    /**
     * Esegue una richiesta di tipo GET
     *
     * @param {string} url
     * @param {any} data
     * @returns {Promise<any>}
     * @memberof Request
     */
    get(url, data) {
        return this.request({
            url: url + paramsSerializer(data),
            method: 'GET',
        });
    }
    /**
     * Esegue una richiesta di tipo POST
     *
     * @param {string} url
     * @param {Object | FormData} data
     * @param {AxiosRequestConfig} options
     * @returns {AxiosPromise}
     * @memberof Request
     */
    post(url, data) {
        const headers = this.setContentTypeFromPostData(this.headers, data);
        return this.request({
            url,
            method: 'POST',
            headers,
            body: data instanceof FormData ? data : JSON.stringify(data),
        });
    }
    /**
     * Esegue una richiesta di tipo DELETE
     *
     * @param {string} url
     * @returns {AxiosPromise}
     * @memberof Request
     */
    delete(url) {
        return this.request({
            url,
            method: 'DELETE',
        });
    }
    /**
     * Esegue una richiesta di tipo PUT
     *
     * @param {string} url
     * @returns {AxiosPromise}
     * @param {AxiosRequestConfig} options
     * @memberof Request
     */
    put(url, data) {
        let method = 'PUT';
        if (data instanceof FormData) {
            data.append('_method', 'PUT');
            method = 'POST';
        }
        return this.request({
            url,
            method,
            headers: this.setContentTypeFromPostData(this.headers, data),
            body: data instanceof FormData ? data : JSON.stringify(data),
        });
    }
    /**
     * Esegue una richiesta di tipo PATCH
     *
     * @param {string} url
     * @param {Object} data
     * @param {AxiosRequestConfig} options
     * @returns {AxiosPromise}
     * @memberof Request
     */
    patch(url, data) {
        return this.request({
            url,
            method: 'PATCH',
            headers: this.setContentTypeFromPostData(this.headers, data),
            body: data instanceof FormData ? data : JSON.stringify(data),
            cache: 'default',
        });
    }
    /**
     * Setta o cancella l'access token nell'header dell'istanza axios
     *
     * @param {string} [access_token]
     * @memberof Request
     */
    setAccessToken(access_token) {
        if (access_token) {
            this.headers['Authorization'] = 'Bearer ' + access_token;
        }
        else {
            delete this.headers['Authorization'];
        }
    }
}
exports.default = Request;
